'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _dateFns = require('date-fns');

var isEqualOrBefore = function isEqualOrBefore(date, before) {
  return (0, _dateFns.isEqual)(date, before) || (0, _dateFns.isBefore)(date, before);
};

var isEqualOrAfter = function isEqualOrAfter(date, after) {
  return (0, _dateFns.isEqual)(date, after) || (0, _dateFns.isAfter)(date, after);
};

var isDisabled = function isDisabled(disabled, date) {
  if ((typeof disabled === 'undefined' ? 'undefined' : _typeof(disabled)) !== 'object' || !(0, _dateFns.isDate)(date)) return true;
  if ((0, _dateFns.isDate)(disabled)) return (0, _dateFns.isEqual)(disabled, date);
  if (!!disabled.after && !!disabled.before) return isEqualOrBefore(date, disabled.before) && isEqualOrAfter(date, disabled.after);
  return !!disabled.before && isEqualOrBefore(date, disabled.before) || !!disabled.after && isEqualOrAfter(date, disabled.after);
};

exports.default = function () {
  var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var date = arguments[1];
  return disabled.some(function (disabledDate) {
    return isDisabled(disabledDate, date);
  });
};